import { useEffect, useState } from 'react';
import {
  getSessionTime,
  ITimerConfig,
  TIME_LIMIT
} from 'entities/tavus/conversation';
import { tavusPersonaStore } from 'entities/tavus/persona';
import { logger } from 'shared/lib';

const formatTime = (duration: number) => {
  if (!duration || duration < 0) return '0:00';

  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;

  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};

export const Timer = () => {
  const currentPersona = tavusPersonaStore((state) => state.currentPersona);
  const [timerDuration, setTimerDuration] = useState(0);
  const [time, setTime] = useState(0);

  useEffect(() => {
    const raw = currentPersona?.timer_config;

    try {
      let parsed: any = raw;

      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }

      if (parsed && typeof parsed.duration === 'number') {
        setTimerDuration(parsed.duration || TIME_LIMIT);
      }
    } catch (e) {
      logger.debug('❌ Failed to parse timer_config:', e);
    }
  }, [currentPersona]);

  useEffect(() => {
    if (currentPersona?.timer_config_enabled) {
      const interval = setInterval(() => {
        const sessionTime = getSessionTime();
        setTime(timerDuration - sessionTime);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [timerDuration]);

  return currentPersona?.timer_config_enabled ? (
    <div className="px-4 py-3 text-sm font-medium">
      Time Remaining: {timerDuration ? formatTime(time) : ''}
    </div>
  ) : null;
};
